exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".board {\n    position: relative;\n    border-radius: 5px;\n    height: calc(100vh - 20px);\n    width: calc(125vh - 20px);\n    margin: 10px;\n    background-color: white;\n    box-shadow: 0 3px 6px rgba(0,0,0,0.16), 0 3px 6px rgba(0,0,0,0.23);\n}\n\n.board.darkMode {\n    background-color: black;\n    box-shadow: none;\n}\n\n@media (orientation:portrait) {\n    .board {\n        height: calc(80vw - 20px);\n        width: calc(100vw - 20px);\n    }\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /Applications/MAMP/htdocs/interactive-board/client/src/app/components/board/board.style.css
// module id = ../../../../../src/app/components/board/board.style.css
// module chunks = main